module.exports = __webpack_public_path__ + "static/media/rekit-logo.d9f8a88d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rekit-logo.svg
// module id = 2182
// module chunks = 0